import {
  faCircleCheck,
  faTimesCircle,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const BenefitPlan = ({ benefit, benefitIicon, redTimesColor }) => {
  return (
    <div className="payment-plans-card-benefit-container">
      <FontAwesomeIcon
        icon={benefitIicon}
        style={redTimesColor ? { color: 'red' } : {}}
        className="payment-plans-card-benefit-icon"
      />
      <div className="payment-plans-card-benefit">{benefit}</div>
    </div>
  );
};

const PaymentPlansCard = ({
  title,
  subTitle,
  price,
  isLast,
  isMiddle,
  isEvery,
  monthAmount,
}) => {
  return (
    <div style={{ position: 'relative' }}>
      {isMiddle ? (
        <div className="payment-plans-card-best-plan">Best Plan</div>
      ) : (
        ''
      )}
      <div
        className={`payment-plans-card-container ${
          isMiddle ? `payment-plans-card-middle-container` : ``
        }`}
      >
        <div className="payment-plans-card-header-container">
          <div className="payment-plans-card-header">{title}</div>
          <div className="payment-plans-card-sub-header">{subTitle}</div>
        </div>
        <div className="payment-plans-card-price">
          <span className="payment-plans-card-price-amount">₦{price}</span>{' '}
          {isEvery ? 'every month' : `for ${monthAmount} months`}
        </div>
        <div className="payment-plans-card-benefits">
          <BenefitPlan
            benefit={'Personalized meal plan'}
            benefitIicon={faCircleCheck}
          />
          <BenefitPlan
            benefit={'Personalized Portion control guide'}
            benefitIicon={faCircleCheck}
          />
          <BenefitPlan
            benefit={'Tailored home workout'}
            benefitIicon={faCircleCheck}
          />
          <BenefitPlan
            benefit={'Personalized intermittent fasting'}
            benefitIicon={faCircleCheck}
          />
          <BenefitPlan
            benefit={'Weight loss community membership'}
            benefitIicon={faCircleCheck}
          />
          {isLast ? (
            <>
              <BenefitPlan
                benefit={'24/7 access to a medical doctor'}
                benefitIicon={faCircleCheck}
              />
              <BenefitPlan
                benefit={'Monthly medical insurance'}
                benefitIicon={faCircleCheck}
              />
            </>
          ) : (
            <>
              <BenefitPlan
                benefit={'24/7 access to a medical doctor'}
                benefitIicon={faTimesCircle}
                redTimesColor={true}
              />
              <BenefitPlan
                benefit={'Monthly medical insurance'}
                benefitIicon={faTimesCircle}
                redTimesColor={true}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentPlansCard;
